import styled from 'styled-components';

export const ConnectionSelectorPopconfirmContentContainer = styled.div`
  width: 200px;
  .description {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
  }

  .divider {
    margin: ${({ theme: { token } }) => token.marginXXS}px 0;
  }
`;
